/**
 * Created by Adam on 26/09/2016.
 */

if (window.jQuery) {
    jQuery(function ($) {
        if ($('#awesomeWeatherUnitCelsius').length !== 0 && $('#awesomeWeatherUnitFahrenheit').length !== 0) {
            var cookieName = 'TCT_weather_unit';

            var unit = getCookie(cookieName, false);
            if (unit == null) {
                unit = 'C';
                setCookie(cookieName, unit, 30, false);
            }

            addClickEvent('C',$('#awesomeWeatherUnitCelsius'),$('#awesomeWeatherUnitFahrenheit'),convertToCelsius);
            addClickEvent('F',$('#awesomeWeatherUnitFahrenheit'),$('#awesomeWeatherUnitCelsius'),convertToFahrenheit);

        }

        function addClickEvent(currentUnit,selector,newSelector,convertFunction)
        {
            if (selector)
            {
                selector.on('click', function () {
                    if (unit!=currentUnit)
                    {
                        var degreesSelector = $('#awesomeWeatherDegrees', '.awesome-weather-current-temp'),
                            symbol,
                            degrees;

                        if (degreesSelector != null) {
                            symbol = degreesSelector.children();
                            degrees = degreesSelector.text().split(symbol.html())[0];

                            degrees = convertFunction(degrees);
                            newSelector.removeClass('selected');
                            selector.addClass('selected');
                            unit = currentUnit;
                            degreesSelector.html(degrees).append(symbol);
                            setCookie(cookieName, unit, 30, false);
                        }
                    }


                });
            }

        }
        function convertToFahrenheit(degrees) {
            var result = Math.round(degrees * (9/5) + 32);
            return result;

        }

        function convertToCelsius(degrees) {
            var result= Math.round(((degrees - 32) / (9/5)));
            return result;
        }
        function changeSymbol(selector,deleteClass,newClass)
        {
            if (selector)
            {
                selector.removeClass(deleteClass);
                selector.addClass(newClass);
            }
        }
    });
}
